import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"city-ancient-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.0016 2C12.0016 4.66661 15.0559 7.05546 17 7.77773V8.0001H16.9996V12H20V21H4V12H7.00195V8H7.00234V7.77695C8.94726 7.05373 12.0016 4.66565 12.0016 2Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12.002 21L12.002 17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.00001 21H3M4.00001 21H20M4.00001 21L4 12M20 21H21M20 21L20 12M20 12L4 12M20 12H21M4 12H3M6 8C7.6 8 12.0016 5.2 12.0016 2C12.0016 5.2 16.4 8 18 8M7.00195 8L16.9996 8L17 12M7 8V12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CityAncient1 = Vue.extend<IconProps>({
  name: 'CityAncient1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'city-ancient-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CityAncient1;
